import { Logout } from "@mui/icons-material";
import {
  Tooltip,
  IconButton,
  Avatar,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../../shared/Contexts";
import { useTranslation } from "react-i18next";

export const Profile = () => {
  const { t } = useTranslation();
  const authenticate = useContext(AuthenticationContext);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleProfileNavigate = () => {
    navigate("/profile");
  };
  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    sessionStorage.clear();
    localStorage.clear();
    authenticate.updateToken("");
    navigate("/login");
  };
  return (
    <>
      <Tooltip title={t("opva.profileSettings")}>
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={open ? "profile-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <Avatar sx={{ width: 24, height: 24, marginRight: 2 }} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="profile-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 25,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleProfileNavigate}>
          <Avatar />
          <div>
            <div>
              <Typography variant="labelLarge" className="fw-bold">
                {authenticate.authUserDetails.employeeFirstName}
              </Typography>
            </div>
            <div>
              <Typography variant="labelNormal">
                {authenticate.authUserDetails.employeeMail}
              </Typography>
            </div>
          </div>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t("opva.logout")}
        </MenuItem>
      </Menu>
    </>
  );
};
